import { privateHttp } from "~/config/axios";
import { API_ENDPOINTS } from "~/config/endpoints";
import {
  DefaultPetRequest,
  PetCalendarList,
  UserPhotoAlbumResponse,
  UserPhotoRequest,
  UserPhotoResponse,
} from "~/types/common";
import { useQuery } from "@tanstack/react-query";

export const getPetList = async () => {
  try {
    const { data } = await privateHttp.get(API_ENDPOINTS.MAIN.PETLIST);
    // console.log("data", data);
    return data.data;
  } catch (error) {
    console.error("API 호출 에러:", error);
    throw error;
  }
};

export const getPetcalendarList = async (request: PetCalendarList) => {
  try {
    const { data } = await privateHttp.get(API_ENDPOINTS.MAIN.PETCALENDARLIST, {
      params: request,
    });
    // console.log("data", data);
    return data.data;
  } catch (error) {
    console.error("API 호출 에러:", error);
    throw error;
  }
};

export const getPetScheduleList = async (request: DefaultPetRequest) => {
  try {
    const { data } = await privateHttp.get(API_ENDPOINTS.MAIN.PETSCHEDULELIST, {
      params: request,
    });
    // console.log("data", data);
    return data.data;
  } catch (error) {
    console.error("API 호출 에러:", error);
    throw error;
  }
};

// User Photo Album 조회
const getUserPhotoAlbum = async (): Promise<UserPhotoAlbumResponse> => {
  try {
    const { data } = await privateHttp.get<UserPhotoAlbumResponse>(
      API_ENDPOINTS.USER_PHOTO.ALBUM
    );
    return data;
  } catch (error) {
    console.error("사용자 포토 앨범 조회 API 호출 에러:", error);
    throw error;
  }
};

export const useUserPhotoAlbum = () => {
  return useQuery({
    queryKey: ["user-photo-album"],
    queryFn: getUserPhotoAlbum,
    staleTime: 5 * 60 * 1000, // 5분
    gcTime: 10 * 60 * 1000, // 10분
    refetchOnMount: "always", // 갤러리 화면 들어올 때마다 최신 앨범 조회
  });
};

// User Photo 상세 조회
const getUserPhoto = async (
  params: UserPhotoRequest
): Promise<UserPhotoResponse> => {
  try {
    const { data } = await privateHttp.get<UserPhotoResponse>(
      `${API_ENDPOINTS.USER_PHOTO.DETAIL}?albumSeq=${params.albumSeq}`
    );
    return data;
  } catch (error) {
    console.error("사용자 포토 상세 조회 API 호출 에러:", error);
    throw error;
  }
};

export const useUserPhoto = (albumSeq: number) => {
  return useQuery({
    queryKey: ["user-photo", albumSeq],
    queryFn: () => getUserPhoto({ albumSeq }),
    enabled: !!albumSeq,
    staleTime: 5 * 60 * 1000, // 5분
    gcTime: 10 * 60 * 1000, // 10분
  });
};
